module.exports = __webpack_public_path__ + "static/media/icons.d9ee23d5.woff";


//////////////////
// WEBPACK FOOTER
// ./src/icons/icons.woff
// module id = 428
// module chunks = 0